// @core/api/endpoints/task/delete_view.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/task';

/**
 * Delete view
 * Deletes a saved task view. Removes the view definition only; tasks matched by the view are not affected.
 */
export async function DeleteView(
  view_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/task-views/:view_id`;
  requestPath = requestPath.replace(':view_id', encodeURIComponent(view_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
